export const roles = {
  admin: ["TOM_MASTER_USER", "TOM_SUPER_USER", "TOM_ADMIN", "TOM_SALES"],
  company: [
    "COMPANY_SUPER_USER",
    "COMPANY_ADMIN",
    "COMPANY_USER",
    "COMPANY_BUSINESS_ACCESS",
  ],
  onlyCompany: [
    "COMPANY_ADMIN",
    "COMPANY_USER",
    "COMPANY_BUSINESS_ACCESS",
  ],
  onlyCompanyAdminAndSales: [
    "TOM_ADMIN",
    "TOM_SALES",
  ],
  rolesThatCantAccessAiInsights: [
    "TOM_SUPER_USER",
    "TOM_ADMIN",
    "TOM_SALES",
    "COMPANY_BUSINESS_ACCESS",
  ]
};
